module.exports = __webpack_public_path__ + "static/media/August_2026_3.caaa306a.webp";